export default __webpack_public_path__ + "static/media/back2.f317a148.png";